import { LongPathTypeName, PathCode, PathName } from 'src/app/shared/enum/path-type.enum';

export enum Product {
  HC = 'HC',
  HP = 'HP',
  HS = 'HS',
  HT = 'HT',
  HL = 'HL',
  HG = 'HG',
  HR = 'HR',
  HE = 'HE',
  HA = 'HA',
  BS = 'BS',
  HN = 'HN',
}

export interface ProductInfo {
  code: Product;
  label: string;
  logo: string;
  longName: string;
  name: string;
  codes: PathCode[];
}

const productInfoMap: ProductInfo[] = [
  {
    code: Product.HN,
    label: 'Essentielle',
    logo: '',
    name: PathName.ESSENTIELLE,
    longName: LongPathTypeName.ESSENTIELLE,
    codes: [PathCode.ESS],
  },
  // No need logo for this product
  {
    code: Product.HC,
    label: 'Confort',
    logo: '',
    name: PathName.CONFORT,
    longName: LongPathTypeName.CONFORT,
    codes: [PathCode.CON, PathCode.CON2],
  },
  {
    code: Product.HC,
    label: 'Confort+',
    logo: '',
    longName: LongPathTypeName.CONFORT,
    name: PathName.CONFORT_PLUS,
    codes: [PathCode.CONP, PathCode.CONP2],
  },
  {
    code: Product.HE,
    label: 'Etudiant',
    logo: '',
    longName: LongPathTypeName.ETUDIANT,
    name: PathName.ETUDIANT,
    codes: [PathCode.ETU],
  },
  {
    code: Product.HS,
    label: 'Solidaire',
    logo: '',
    longName: LongPathTypeName.SOLIDAIRE,
    name: PathName.SOLIDAIRE,
    codes: [PathCode.SOL, PathCode.SOL2],
  },
  {
    code: Product.BS,
    label: 'Solidaire',
    logo: '',
    name: PathName.SOLIDAIRE,
    longName: LongPathTypeName.BAILLEUR_SOCIAL,
    codes: [PathCode.BSOL],
  },
  {
    code: Product.HP,
    label: 'Paris',
    logo: 'assets/common/Paris.svg',
    name: PathName.PARIS,
    longName: LongPathTypeName.PARIS,
    codes: [PathCode.PAR2, PathCode.PAR],
  },
  {
    code: Product.HT,
    label: 'Tourcoing',
    logo: 'assets/common/Tourcoing.svg',
    name: PathName.TOURCOING,
    longName: LongPathTypeName.TOURCOING,
    codes: [PathCode.TOU, PathCode.TOU2],
  },
  {
    code: Product.HL,
    label: 'Lille',
    logo: 'assets/common/LilleHellemmesLomme.svg',
    name: PathName.LILLE,
    longName: LongPathTypeName.LILLE,
    codes: [PathCode.LIL, PathCode.LIL2],
  },
  {
    code: Product.HG,
    label: 'Grenoble',
    logo: 'assets/common/GrenobleAlpesMetropole.svg',
    name: PathName.GRENOBLE,
    longName: LongPathTypeName.GRENOBLE,
    codes: [PathCode.GRE],
  },
  {
    code: Product.HR,
    label: 'Creteil',
    logo: 'assets/common/Creteil.svg',
    name: PathName.CRETEIL,
    longName: LongPathTypeName.CRETEIL,
    codes: [PathCode.CRE],
  },
  {
    code: Product.HA,
    label: 'Marseille',
    logo: 'assets/common/Marseille.svg',
    longName: LongPathTypeName.MARSEILLE,
    name: PathName.MARSEILLE,
    codes: [PathCode.MAR],
  },
];

export const getProductInfo = (productCode: string): ProductInfo | undefined => {
  return productInfoMap.find((productInfo) => productInfo.code === productCode);
};

export function getImgPlafond(productCode: string, brand: string): string {
  return 'assets/common/{0}/popup-info/plafonds{1}.png'.replace('{0}', brand).replace('{1}', productCode);
}

export function getProductFromCode(code: string): ProductInfo | undefined {
  const productInfo = productInfoMap.find((product) => product.codes.includes(code as PathCode));
  return productInfo ? productInfo : undefined;
}
